import * as yup from "yup";

export const validationSchema = yup.object().shape({
  AccountNumber: yup
    .string()
    .nullable()
    .notRequired()
    .matches(/^\d*$/, "Invalid account number")
    .test(
      "valid-length",
      "Invalid account number",
      (value) => !value || value.length === 12
    ),
  PhoneNumber: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      "empty-or-valid",
      "Phone number must be in 999-999-9999 format",
      (value) => !value || /^\d{3}-\d{3}-\d{4}$/.test(value)
    ),
  HouseNumber: yup.string().nullable().notRequired(),
  MobileNumber: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      "empty-or-valid",
      "Invalid phone/mobile number",
      (value) => !value || /^\d{3}-\d{3}-\d{4}$/.test(value)
    ),
});
